import { useCallback, useMemo } from 'react';

import { useGetSupportUsersQuery } from 'api/admin-roles-api';

export const useSupportUserNames = () => {
  const { data: supportUsers } = useGetSupportUsersQuery();

  const supportUserNames = useMemo(() => {
    return (
      supportUsers?.reduce((acc, user) => {
        acc[user.id] = `${user.first_name || ''} ${user.last_name || ''}`.trim();
        return acc;
      }, {}) || {}
    );
  }, [supportUsers]);

  const getSupportUser = useCallback(
    supportUserId => {
      return supportUserNames[supportUserId] || '';
    },
    [supportUserNames],
  );

  return {
    supportUserNames,
    getSupportUser,
    supportUsers,
  };
};
